


export const dropDownMenu = () => {

	const dropDowmSel = $(".js-dropdownMenu .js-dropdownMenu__button");
	if(dropDowmSel.length>0){
		//$(".js-dropdownMenuContainer").hide();
		dropDowmSel.on("click", function(){
			$(this).closest(".js-dropdownMenu").find(".js-dropdownMenuContainer").toggle("medium");
		})
		tourStateSelected();
	}

};

const tourStateSelected = () => {
	const stateSel = $(".js-dropdownMenu .js-state");
	if(stateSel.length>0){
		stateSel.on("click", function(){
			const selectedState = $(this).attr("data-statedata");
			if(selectedState== "all"){
				$(".tourListPanel").css("display", "flex");
			}else{
				$(".tourListPanel:not(.tourListPanel__title)").css("display", "none");
				//$(".tourListPanel.tourListPanel__title").css("display", "none");
				//$(".tourListPanel.tourListPanel__title").css("display", "flex");
				$(".tourListPanel[data-state='"+selectedState+"'").css("display", "flex");
			}
			$(this).closest(".js-dropdownMenu").find(".js-dropdownMenuContainer").toggle("medium");
		})
	}

};